"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  default: {
    margin: 0,
    iconSize: 18,
    iconColor: '#C0C0C0',
    iconHoverColor: '#DA1157',
    tooltipWidth: 340,
    tooltipOffset: -30,
    tooltipBackgroundColor: '#fff',
    tooltipBorderRadius: '3px',
    tooltipPadding: '10px',
    tooltipShadow: true,
    tooltipBorderWidth: '0',
    tooltipBorderColor: 'transparent',
    zIndex: 9999
  }
};
exports.default = _default;